import React, { useEffect } from "react";
import "./App.css";
import { ParallaxProvider } from "react-scroll-parallax";
import { HomePage, CitySelectionPage } from "./pages";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { FormPage } from "./pages/FormPage";
import { SuccessPage } from "./pages/SuccessPage";
import { ContactPage } from "./pages/ContactPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { ScrollToTop } from "./common/components/ScrollToTop";
import { AppContextProvider } from "./context";
import { AboutPage } from "./pages/AboutPage";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "./common/components/ErrorFallBack";
import { AccessDeniedPage } from "./common/components/AccessDenied";
import { HowItWorksPage } from "./pages/HowItWorks";
import { Navbar } from "./components/NavBar";
import { initGA, trackPageView } from "./analytics/ga";

/* ===============================
   ROUTE ANALYTICS TRACKER
================================ */

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

function App() {
  /* Initialize GA ONCE */
  useEffect(() => {
    initGA();
  }, []);

  return (
    <AppContextProvider>
      <ParallaxProvider>
        <BrowserRouter>
          {/* Track route changes for GA */}
          <RouteChangeTracker />

          <Navbar />
          <ScrollToTop />

          {/* GLOBAL ERROR BOUNDARY */}
          <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onReset={() => {
              window.location.reload();
            }}
          >
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/city-selection" element={<CitySelectionPage />} />
              <Route path="/form" element={<FormPage />} />
              <Route path="/success" element={<SuccessPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/admin" element={<AccessDeniedPage />} />
              <Route path="/how-it-works" element={<HowItWorksPage />} />
            </Routes>
          </ErrorBoundary>
        </BrowserRouter>
      </ParallaxProvider>
    </AppContextProvider>
  );
}

export default App;
